import React from 'react'
import { Box } from '@mui/material'
import { EmtTypography, EmtIcon } from 'emt-components-v2'

interface ConnaissanceBoxProps {
  iconClass?: string
  text?: string
}

export const ConnaissanceBox: React.FC<ConnaissanceBoxProps> = ({ iconClass, text }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        gap: '13px',
        padding: '15px',
        backgroundColor: '#fff',
        borderRadius: '16px',
        border: '1px solid #E8E8EA',
      }}
    >
      <EmtIcon className={iconClass} sx={{ fontWeight: 100, fontSize: '23px!important', color: '#AE59C6' }} />
      <EmtTypography variant="body2" fontWeight="600" color="#1D1929">
        {text}
      </EmtTypography>
    </Box>
  )
}
